module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-text', [_c('h1', [_vm._v("Правила использования сертификата")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6996870d","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cert/Cert.vue
// module id = a5560bc166b68334bb55
// module chunks = 5